import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { RtGpsLocationService } from './gps-location.service';
import { BourqueCoreModule } from '@bds/core';
import { MatSelectModule } from '@angular/material/select';
import { BdsDateTimePickerModule } from '@bds/smart-components';
import { MatTableModule } from '@angular/material/table';
import {
    BdsGpsLocationMapComponent,
    LeafletSateliteLayerOptions,
    LeafletStreetLayerOptions,
} from './bds-gps-location-map/bds-gps-location-map.component';
import { GpsLocationDetailsComponent } from './gps-location-details/gps-location-details.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RtGpsAlertService } from './gps-alert.service';

@NgModule({
    declarations: [BdsGpsLocationMapComponent, GpsLocationDetailsComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        BourqueCoreModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatSelectModule,
        BdsDateTimePickerModule,
        MatCardModule,
        MatProgressSpinnerModule,
        MatTableModule,
        FontAwesomeModule,
        MatToolbarModule,
    ],
    providers: [
        RtGpsLocationService,
        RtGpsAlertService,
        {
            provide: LeafletSateliteLayerOptions,
            useValue: {
                attribution:
                    '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
                mapUrl: 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png',
            },
        },
        {
            provide: LeafletStreetLayerOptions,
            useValue: {
                attribution:
                    '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
                mapUrl: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            },
        },
    ],
    exports: [BdsGpsLocationMapComponent, GpsLocationDetailsComponent],
})
export class RtGpsLocationModule {}
